import React, { createContext, useState, useContext } from 'react';
import InfoToast from '../../components/utils/InfoToast';

const ToastContext = createContext();

export const ToastType = {
  SUCCESS: 'success',
  DANGER: 'error',
};

export const ToastProvider = ({ children }) => {
  const [toastInfo, setToastInfo] = useState({
    show: false,
    message: '',
    type: '',
  });

  const showToast = (message, type) => {
    setToastInfo({ show: true, message, type });
  };

  const showSuccessToast = (message) => {
    setToastInfo({ show: true, message, type: ToastType.SUCCESS });
  };

  const showErrorToast = (message) => {
    setToastInfo({ show: true, message, type: ToastType.DANGER });
  };

  const hideToast = () => {
    setToastInfo({ ...toastInfo, show: false });
  };

  return (
    <ToastContext.Provider
      value={{ showToast, showSuccessToast, showErrorToast, hideToast }}
    >
      <InfoToast
        show={toastInfo.show}
        message={toastInfo.message}
        type={toastInfo.type}
        onClose={hideToast}
      />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
